import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';

// Licenciamento por assento (sistemas 10.9+): instalacoes = vinculo contrato -> servidor
// do SpeedyAgent. So leitura + revogar / desbloquear trocas (a API nao tem insert/update).
class LicencaService extends BaseService {
  constructor() {
    super(`${ConfigApi.licencaURL}`);
  }

  getFilter() {
    return new Filter();
  }

  async revogar(id, motivo) {
    this.setLoading(true);
    try {
      const response = await this.api.post(`${this.url}/${id}/revogar`, { motivo });
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  // zera a contagem de trocas de servidor do CONTRATO (nao de uma instalacao)
  async desbloquear(idCliente, motivo) {
    this.setLoading(true);
    try {
      const response = await this.api.post(`${this.url}/desbloquear/${idCliente}`, { motivo });
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }
}

class Filter {
  constructor() {
    this.numeroContrato = '';
    this.situacao = 'A';
    this.limit = 11;
    this.page = 0;
  }
}
export default new LicencaService();
